import { api } from "@/services";
import { useState } from "react";

export async function useGetPartnerDealerShip(cnpj) {
  try {
    const { data } = await api.get(`PartnerDealership/GetPartnerDealership?search=${cnpj}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}
